import { BMEventsType, type PageSegmentLoadPerformanceEventConfig } from '../types';

export const isPageSegmentLoadConfig = (
	data: any,
): data is PageSegmentLoadPerformanceEventConfig => {
	return data.type === BMEventsType.PAGE_SEGMENT_LOAD;
};
